import { FC } from "react";

interface NotificationsProps {}

const Notifications: FC<NotificationsProps> = () => (
  <>Notifications</>
);

export default Notifications;
